import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const designProject = {
    "id": "Ai7OTz",
    "name": "Design project",
    "img": "/app/static/templates/design/design-project.jpg",
    "description": "Project structure build to manage phases of a creative project.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Design & UX',
    demoFolderColor: 1
};

const inspiration = {
    "id": "lGwK9r",
    "name": "Inspiration and resources",
    "img": "/app/static/templates/design/inspirations.jpg",
    "description": "Library of useful resources and inspirations.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Design & UX',
    demoFolderColor: 1
};

const assets = {
    "id": "UOswWg",
    "name": "Digital Assets Mngt.",
    "img": "/app/static/templates/design/assets.jpg",
    "description": "File repository that can be shared with all users or within one project.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Design & UX',
    demoFolderColor: 1
};

const requests = {
    "id": "zeLytU",
    "name": "Design Requests",
    "img": "/app/static/templates/design/requests.jpg",
    "description": "Convenient design request tracker to prioritize and execute.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Design & UX',
    demoFolderColor: 1
};

export default {
    id: 'design',
    name: "Design & UX",
    items: [

        designProject,
        requests,

        inspiration,
        assets,

    ]
};